import React, { forwardRef, useId } from 'react';
import Icon from '../AppIcon';

const Select = forwardRef(({ 
  label, 
  id,
  value = '', 
  onChange, 
  options = [], 
  placeholder = 'Select an option',
  error,
  required = false,
  helperText,
  disabled = false,
  className = '',
  containerClassName = '',
  fullWidth = true,
  ...props
}, ref) => {
  const generatedId = useId();
  const selectId = id || generatedId;

  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  const baseClass = error 
    ? "flex h-10 rounded-md border border-red-500 bg-background px-3 py-2 text-base ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"
    : "flex h-10 rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm";
  
  const widthClass = fullWidth ? "w-full" : "w-auto";

  return (
    <div className={`space-y-2 ${containerClassName}`}>
      {label && (
        <label htmlFor={selectId} className="block text-sm font-medium text-text-primary">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <select
        id={selectId}
        ref={ref}
        id={selectId}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        className={`${baseClass} ${widthClass} ${className}`}
        {...props}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option 
            key={typeof option === 'string' ? option : option.value} 
            value={typeof option === 'string' ? option : option.value}
          >
            {typeof option === 'string' ? option : option.label}
          </option>
        ))}
      </select>
      {error && (
        <p className="text-sm text-red-600 flex items-center gap-1">
          <Icon name="AlertCircle" size={14} />
          {error}
        </p>
      )}
      {helperText && !error && (
        <p className="text-sm text-gray-500">
          {helperText}
        </p>
      )}
    </div>
  );
});

Select.displayName = 'Select';

export default Select;
